import type { RouteKey } from '@/router/routesPathConfig';
import type { CompanySettingsDestinationKey } from '@/abilities/companySettings/vocabulary';

/** The route that shows each settings destination. */
export const companySettingsDestinationRoutes: Record<CompanySettingsDestinationKey, RouteKey> = {
  root: 'COMPANY_SETTINGS',
  general: 'COMPANY_SETTINGS_GENERAL',
  'general.main': 'COMPANY_SETTINGS_GENERAL_MAIN',
  'general.features': 'COMPANY_SETTINGS_GENERAL_FEATURES',
  users: 'COMPANY_SETTINGS_USERS',
  integrations: 'COMPANY_SETTINGS_INTEGRATIONS',
  applications: 'COMPANY_SETTINGS_APPLICATIONS',
  vendorPreferences: 'COMPANY_SETTINGS_VENDOR_PREFERENCES',
  'vendorPreferences.general': 'COMPANY_SETTINGS_VENDOR_PREFERENCES_GENERAL',
  'vendorPreferences.policies': 'COMPANY_SETTINGS_VENDOR_PREFERENCES_POLICIES',
  approvals: 'COMPANY_SETTINGS_APPROVALS',
  'approvals.approvers': 'COMPANY_SETTINGS_APPROVALS_APPROVERS',
  'approvals.basicGroups': 'COMPANY_SETTINGS_APPROVALS_BASIC_GROUPS',
  'approvals.advancedGroups': 'COMPANY_SETTINGS_APPROVALS_ADVANCED_GROUPS',
  'approvals.vendorBased': 'COMPANY_SETTINGS_APPROVALS_VENDOR_BASED',
  'approvals.features': 'COMPANY_SETTINGS_APPROVALS_FEATURES',
  bankFeed: 'COMPANY_SETTINGS_BANK_FEED',
  'bankFeed.connections': 'COMPANY_SETTINGS_BANK_FEED_CONNECTIONS',
  'bankFeed.synchronization': 'COMPANY_SETTINGS_BANK_FEED_SYNCHRONIZATION',
  'bankFeed.usersAndPermissions': 'COMPANY_SETTINGS_BANK_FEED_USERS_AND_PERMISSIONS',
};
